import * as React from "react";
function SvgFormattingCheck(props) {
  return /* @__PURE__ */ React.createElement("svg", { width: 8, height: 6, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.707.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L3 3.586 6.293.293a1 1 0 011.414 0z", fill: "#2C6ECB" }));
}
export default SvgFormattingCheck;
